import { useState } from 'react';
import { FiltersMap, OptionalFiltersMap } from '@wix/bex-core';
import {
  AmbassadorCollectionConfig,
  useWixPatternsContainer,
  useCreateAmbassadorCollection,
} from '@wix/bex-core/react';
import { InfiniteScrollTableState } from '../../state';

export function useAmbassadorInfiniteScrollTable<
  T,
  F extends FiltersMap = OptionalFiltersMap,
>(config: AmbassadorCollectionConfig<T, F>) {
  const createCollection = useCreateAmbassadorCollection();
  const container = useWixPatternsContainer();

  const [state] = useState(
    () =>
      new InfiniteScrollTableState({
        collection: createCollection<T, F>(config),
        container,
      }),
  );

  return state;
}

export { useAmbassadorInfiniteScrollTable as useAmbassadorTable };
